import React from 'react';
import { Link } from 'react-router-dom';

export class AppFooter extends React.Component {
  render() {
    return (
      <>
        <div class="d-md-none m-0 p-0 pt-2 text-info text-center border-top border-1 border-body">
          @ All Copyrights Reserved 2025<br/><Link to="https://www.yawinsoftwares.com" class="text-decoration-none">Yawin softwares</Link>
        </div>
        <div class="d-none d-md-block m-0 p-0 pt-2 text-info text-center border-top border-1 border-body">
          @ All Copyrights Reserved 2025 - <Link to="https://www.yawinsoftwares.com" class="text-decoration-none">Yawin softwares</Link>
        </div>      
      </>      
  );
  };    
}
